<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col">
          <h1 class="title-list color-red bis mt-3">
            <span
              v-if="
                $route.params.salerent == 'sales' &&
                  $route.params.where == 'monaco'
              "
              >{{ $t("translation.Ventes") }} Monaco</span
            >
            <span
              v-if="
                $route.params.salerent == 'rents' &&
                  $route.params.where == 'monaco'
              "
              >{{ $t("translation.Locations") }} Monaco</span
            >
            <span
              v-if="
                $route.params.salerent == 'sales' &&
                  $route.params.where == 'france'
              "
              >{{ $t("translation.Ventes") }}
              {{ $t("translation.Cote_dazur") }}</span
            >
            <span
              v-if="
                $route.params.salerent == 'rents' &&
                  $route.params.where == 'france'
              "
              >{{ $t("translation.Locations") }}
              {{ $t("translation.Cote_dazur") }}</span
            >
          </h1>
          <p
            v-if="
              $route.params.salerent == 'sales' &&
                $route.params.where == 'monaco'
            "
            v-html="$t('translation.sales_monaco')"
          ></p>
          <p
            v-if="
              $route.params.salerent == 'rents' &&
                $route.params.where == 'monaco'
            "
            v-html="$t('translation.rents_monaco')"
          ></p>
          <p
            v-if="
              $route.params.salerent == 'sales' &&
                $route.params.where == 'france'
            "
            v-html="$t('translation.sales_france')"
          ></p>
          <p
            v-if="
              $route.params.salerent == 'rents' &&
                $route.params.where == 'france'
            "
            v-html="$t('translation.rents_france')"
          ></p>
        </div>
      </div>
      <div class="row">
        <div
          class="col-md-4 col-lg-3"
          v-for="district in districts"
          :key="district.text"
        >
          <div
            class="hot-box"
            :style="'background-image:url(/images/' + district.img + ')'"
            @click="gotoOffers(district)"
          >
            <div class="hot-box-bg">&nbsp;</div>
            <div class="hot-box-bg2">&nbsp;</div>
            <div class="hot-box-info">
              {{ district.text }} ({{ district.nb }})
            </div>
          </div>
          <!-- <div class="district" style="">{{ district.text }} ({{ district.nb }})</div> -->
          <!-- (<span v-for="dist in district.value" :key="dist">{{ dist }}</span
          >) -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  components: {},
  data() {
    return {
      districts: []
    };
  },
  computed: {},
  watch: {
    $route(to, from) {
      this.loadDistricts();
    }
  },
  async mounted() {
    if (this.$route.params.where === "international")
      this.gotoOffers({ value: ["international"] });
    else this.loadDistricts();
  },
  destroyed() {},
  methods: {
    gotoOffers(district) {
      if (district.value[0] == "all" && district.isDistrict)
        district.value[0] = "monaco";
      if (district.value[0] == "all" && !district.isDistrict)
        district.value[0] = "france";
      let t = district.value.join("---");
      if (district.value[0] == "international") t = "international";
      this.$router.push(
        "/offers/" +
          encodeURIComponent(t) +
          "/" +
          this.$route.params.salerent +
          "/types-all/pieces-all/budget-all/1"
      );
    },
    async loadDistricts() {
      let params = {
        salerent: this.$route.params.salerent,
        where: this.$route.params.where,
        lang: this.$store.state.lang
      };
      let response = await this.$axios.get(
        this.$config.server_url + "/web/1.0/districts",
        { params }
      );
      if (!response || !response.data) return;
      this.districts = response.data.data.filter(d => {
        return d.nb;
      });
      // console.log("this.districts", this.districts);
    }
  }
};
</script>
<style scoped lang="scss">
// @import "../../node_modules/bootstrap/scss/bootstrap.scss";
// @import "../scss/styles.scss";
.hot-box {
  height: 200px;
  background-size: cover;
  position: relative;
  cursor: pointer;
  margin-bottom: 30px;
  .hot-box-bg {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: transparent;
    background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.7) 10%,
      rgba(255, 255, 255, 0) 30%
    );
    transition: all 0.5s ease-out;
  }
  .hot-box-info {
    position: absolute;
    width: 100%;
    bottom: 15px;
    color: white;
    font-size: 1.2rem;
    line-height: 1.25rem;
    text-align: center;
    transition: all 0.5s ease-out;
  }
  &:hover {
    .hot-box-info {
      bottom: 45%;
    }
    .hot-box-bg {
      background-color: rgba(0, 0, 0, 0.7);
    }
  }
}

.title-list {
  text-align: center;
  font-size: 30px;
}
</style>
